<template>
  <div
    class="absolute left-[10px] top-[5px] flex gap-3 items-center bg-black px-6 py-5 w-[95%] rounded z-50"
  >
    <div class="text-[#FF0000] text-3xl" id="icon-box">
      <fai icon="hand" />
    </div>
    <span class="text-white">{{ $t("no_connection") }}</span>
  </div>
</template>
<script setup></script>
